module.exports = __webpack_public_path__ + "img/share.a359fef5.png";